import logo from 'assets/images/logo.png';

const Logo = () => {
    return (
        <>
            <img src={logo} alt="logo" width="250" />
        </>
    );
};

export default Logo;
